import { axiosSwagger } from "@/axios";

export const state = {
    tag: {
        loading: false,
        data: [],
        total: 0,
    },
}


export const getters = {
}


export const mutations = {
    // TAG
    tagLoading: (state, loading) => {
        state.tag.loading = loading;
    },
    setTagData: (state, data) => {
        state.tag.data = data;
    },
    setTagTotal: (state, total) => {
        state.tag.total = total;
    },
    addTag: (state, data) => {
        state.tag.data.push(data);
    },
    removeTag: (state, id) => {
        state.tag.data = state.tag.data.filter((el) => el.id !== id);
    },
    updateTag: (state, data) => {
        const index = state.tag.data.findIndex((item) => item.id === data.id);

        if (index !== -1) {
            state.tag.data[index].tagName = data.tagName;
            state.tag.data[index].description = data.description;
        }
    },
}


export const actions = {
    // TAG
    async readTag({ commit }) {
        commit("tagLoading", true);

        return await axiosSwagger
        .get("/api/Tag/All")
        .then((response) => {
            commit("setTagData", response.data);
            commit("setTagTotal", response.data.length);
            commit("tagLoading", false);

            return response;
        })
        .catch(() => {
            commit("tagLoading", false);
        });
    },
    async createTag({ commit }, data) {
        return await axiosSwagger
        .post("/api/Tag/Create", data)
        .then((response) => {
            commit("addTag", response.data);

            return response;
        });
    },
    async deleteTag({ commit }, id) {
        return await axiosSwagger.delete(`/api/Tag/${id}`).then((response) => {
        commit("removeTag", id);

        return response;
        });
    },
    async updateTag({ commit }, data) {
        return await axiosSwagger
        .put(`/api/Tag/${data.id}`, data)
        .then((response) => {
            commit("updateTag", data);

            return response;
        });
    },
}